
export default class ModeratorService {
    constructor(axios) {
        this.axios = axios;
    }


    updateProfile(data) {
        return this.axios.put(`/moderators/${data.id}`, data);
    }

    getConfiguration() {
        return this.axios.get('/workspaces/configuration');
    }

    updatePassword(data) {
        return this.axios.put(`/moderators/resetPassword/${data.id}`, data);
    }
}
